import api from './api';
import { User, Address } from '../types/api';
import { USER_STORAGE_KEY } from '../constants/storageKeys';

/**
 * Serviço de Usuário
 */
const userService = {
  /**
   * Atualiza dados do perfil do usuário
   */
  async updateProfile(data: {
    name?: string;
    email?: string;
    phone?: string;
    birthDate?: string;
  }): Promise<{ user: User }> {
    const response = await api.put<{
      success: boolean;
      data: { user: User };
    }>('/users/profile', data);

    const user = response.data.data.user;

    // Atualizar dados do usuário no localStorage
    if (user) {
      localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
    }

    return { user };
  },

  /**
   * Altera a senha do usuário
   */
  async changePassword(data: {
    currentPassword: string;
    newPassword: string;
  }): Promise<{ message: string }> {
    const response = await api.put<{
      success: boolean;
      data: { message: string };
    }>('/users/password', data);

    return { message: response.data.data.message };
  },

  /**
   * Lista endereços do usuário
   */
  async getAddresses(): Promise<{ addresses: Address[] }> {
    const response = await api.get<{
      success: boolean;
      data: { addresses: Address[] };
    }>('/users/addresses');

    return { addresses: response.data.data.addresses };
  },

  /**
   * Adiciona novo endereço
   */
  async addAddress(
    address: Omit<Address, 'id'>
  ): Promise<{ address: Address }> {
    const response = await api.post<{
      success: boolean;
      data: { address: Address };
    }>('/users/addresses', address);

    return { address: response.data.data.address };
  },

  /**
   * Atualiza endereço
   */
  async updateAddress(
    id: string,
    address: Partial<Address>
  ): Promise<{ address: Address }> {
    const response = await api.put<{
      success: boolean;
      data: { address: Address };
    }>(`/users/addresses/${id}`, address);

    return { address: response.data.data.address };
  },

  /**
   * Remove endereço
   */
  async deleteAddress(id: string): Promise<{ message: string }> {
    const response = await api.delete<{
      success: boolean;
      data: { message: string };
    }>(`/users/addresses/${id}`);

    return { message: response.data.data.message };
  },
};

export default userService;

